import { Typography, Box, Button, ClickAwayListener } from "@mui/material";
import { useState } from "react";
import { useStyles } from "./style";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function OverViewTitle({
  title,
  theme,
  selectedTaka,
  setSelectedTaka,
}) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const classes = useStyles({ theme });
  if (title === undefined) return null;
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        top: 0,
        mt: 2,
      }}
    >
      <Typography
        sx={{
          mb: 1,
          fontWeight: "700",
          fontSize: "20px",
          lineHeight: "45px",
          color: theme.palette.text.primary,
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
        }}
      >
        <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
          <Box sx={{ position: "relative" }}>
            <Button
              variant="contained"
              onClick={() => setDropdownOpen((open) => !open)}
              className={classes.selectionDropBtn}
              sx={{
                width: "150px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
              }}
            >
              {selectedTaka}
              <ArrowDropDownIcon className={classes.arrowIcon} />
            </Button>

            {dropdownOpen && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",
                  position: "absolute",
                  top: "45px",
                  right: 0,
                  zIndex: 100,
                  background: theme.palette.background.paper,
                  boxShadow: 2,
                  p: 1,
                  width: "180px",
                }}
              >
                <Button
                  variant="contained"
                  className={classes.selectionDropBtn}
                  onClick={() => {
                    setSelectedTaka("Taka 3.1");
                    setDropdownOpen(false);
                  }}
                  disabled={selectedTaka === "Taka 3.1"}
                >
                  Taka 3.1
                </Button>
                <Button
                  variant="contained"
                  className={classes.selectionDropBtn}
                  onClick={() => {
                    setSelectedTaka("Taka 4.1 a");
                    setDropdownOpen(false);
                  }}
                  disabled={selectedTaka === "Taka 4.1 a"}
                >
                  Taka 4.1 a
                </Button>
                <Button
                  variant="contained"
                  className={classes.selectionDropBtn}
                  onClick={() => {
                    setSelectedTaka("Taka 4.1 c");
                    setDropdownOpen(false);
                  }}
                  disabled={selectedTaka === "Taka 4.1 c"}
                >
                  Taka 4.1 c
                </Button>
              </Box>
            )}
          </Box>
        </ClickAwayListener>
      </Box>
    </Box>
  );
}
